var _rect, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivecyDownloadTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#F8F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.5 20.3C13.5 18.6198 13.5 17.7798 13.827 17.138C14.1146 16.5735 14.5735 16.1146 15.138 15.827C15.7798 15.5 16.6198 15.5 18.3 15.5H28.7C30.3802 15.5 31.2202 15.5 31.862 15.827C32.4265 16.1146 32.8854 16.5735 33.173 17.138C33.5 17.7798 33.5 18.6198 33.5 20.3V26.7C33.5 28.3802 33.5 29.2202 33.173 29.862C32.8854 30.4265 32.4265 30.8854 31.862 31.173C31.2202 31.5 30.3802 31.5 28.7 31.5H18.3C16.6198 31.5 15.7798 31.5 15.138 31.173C14.5735 30.8854 14.1146 30.4265 13.827 29.862C13.5 29.2202 13.5 28.3802 13.5 26.7V20.3Z",
    fill: "url(#paint0_linear_7822_78632)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 25.5C18.5784 25.5 19.25 24.8284 19.25 24C19.25 23.1716 18.5784 22.5 17.75 22.5C16.9216 22.5 16.25 23.1716 16.25 24C16.25 24.8284 16.9216 25.5 17.75 25.5Z",
    fill: "url(#paint1_linear_7822_78632)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 25.5C18.9926 25.5 20 26.5074 20 27.75V28.5H15.5V27.75C15.5 26.5074 16.5074 25.5 17.75 25.5Z",
    fill: "url(#paint2_linear_7822_78632)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 26C21.5 25.7239 21.7239 25.5 22 25.5H30C30.2761 25.5 30.5 25.7239 30.5 26C30.5 26.2761 30.2761 26.5 30 26.5H22C21.7239 26.5 21.5 26.2761 21.5 26Z",
    fill: "url(#paint3_linear_7822_78632)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 28C21.5 27.7239 21.7239 27.5 22 27.5H26C26.2761 27.5 26.5 27.7239 26.5 28C26.5 28.2761 26.2761 28.5 26 28.5H22C21.7239 28.5 21.5 28.2761 21.5 28Z",
    fill: "url(#paint4_linear_7822_78632)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7822_78632",
    x1: 18.4231,
    y1: 30.1838,
    x2: 47.5743,
    y2: -10.1757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7822_78632",
    x1: 19.1923,
    y1: 28.0064,
    x2: 26.5501,
    y2: 7.63296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7822_78632",
    x1: 19.1923,
    y1: 28.0064,
    x2: 26.5501,
    y2: 7.63296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7822_78632",
    x1: 19.1923,
    y1: 28.0064,
    x2: 26.5501,
    y2: 7.63296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7822_78632",
    x1: 19.1923,
    y1: 28.0064,
    x2: 26.5501,
    y2: 7.63296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivecyDownloadTravel);
export default __webpack_public_path__ + "static/media/privecy-download-travel.2b3b9ddf38cd0b6380f27b7e1b9e0169.svg";
export { ForwardRef as ReactComponent };